module.exports = __webpack_public_path__ + "img/rosariobalmaceda.fe5d033e.jpg";